import React, { useState } from 'react';
import { LegalPopup } from './LegalPopup';
export function Footer() {
  const [activePopup, setActivePopup] = useState<string | null>(null);
  const openPopup = (popupId: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setActivePopup(popupId);
  };
  const closePopup = () => {
    setActivePopup(null);
  };
  const terminos = <div className="space-y-4 text-gray-700" data-id="element-71">
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-72">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-73">
        Al acceder y utilizar el programa "30 Días Frecuencia Prohibida", usted
        acepta estar legalmente obligado por estos Términos y Condiciones. Si no
        está de acuerdo con alguno de estos términos, no debe utilizar este
        programa.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-74">
        2. Descripción del Servicio
      </h3>
      <p data-id="element-75">
        "30 Días Frecuencia Prohibida" es un programa de desarrollo personal que
        utiliza frecuencias binaurales y técnicas de meditación para ayudar a
        los usuarios a elevar su frecuencia vibratoria. El programa incluye
        audios, videos, material escrito y acceso a una comunidad privada.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-76">3. Uso del Programa</h3>
      <p data-id="element-77">
        El acceso al programa es personal e intransferible. Está prohibida la
        reproducción, distribución, modificación o venta de cualquier contenido
        del programa sin autorización explícita.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-78">
        4. Propiedad Intelectual
      </h3>
      <p data-id="element-79">
        Todo el contenido del programa, incluyendo pero no limitado a textos,
        gráficos, logos, imágenes, clips de audio, descargas digitales y
        software, es propiedad de los creadores del programa y está protegido
        por leyes de propiedad intelectual.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-80">
        5. Limitación de Responsabilidad
      </h3>
      <p data-id="element-81">
        El programa se ofrece "tal cual" sin garantías de ningún tipo. Los
        resultados pueden variar de persona a persona. El programa no sustituye
        ningún tratamiento médico o psicológico profesional.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-82">
        6. Política de Reembolso
      </h3>
      <p data-id="element-83">
        Ofrecemos una garantía de satisfacción de 7 días. Si después de seguir
        el programa durante 7 días no experimentas resultados, te devolvemos el
        100% de tu dinero. Para solicitar un reembolso, debes contactar a
        soporte@frecuenciaprohibida.com explicando tu experiencia.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-84">7. Modificaciones</h3>
      <p data-id="element-85">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-86">8. Ley Aplicable</h3>
      <p data-id="element-87">
        Estos términos se regirán e interpretarán de acuerdo con las leyes del
        país de residencia del creador del programa, sin tener en cuenta sus
        disposiciones sobre conflictos de leyes.
      </p>
    </div>;
  const privacidad = <div className="space-y-4 text-gray-700" data-id="element-88">
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-89">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-90">
        Recopilamos información personal como nombre, dirección de correo
        electrónico y datos de pago cuando te registras en nuestro programa.
        También podemos recopilar información sobre cómo interactúas con nuestro
        contenido para mejorar la experiencia del usuario.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-91">
        2. Uso de la Información
      </h3>
      <p data-id="element-92">Utilizamos la información recopilada para:</p>
      <ul className="list-disc pl-6 space-y-2" data-id="element-93">
        <li data-id="element-94">Proporcionar acceso al programa y sus materiales</li>
        <li data-id="element-95">Procesar pagos y gestionar tu cuenta</li>
        <li data-id="element-96">Enviarte comunicaciones relacionadas con el programa</li>
        <li data-id="element-97">Mejorar nuestros servicios y desarrollar nuevos contenidos</li>
        <li data-id="element-98">Cumplir con obligaciones legales</li>
      </ul>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-99">
        3. Protección de Datos
      </h3>
      <p data-id="element-100">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra accesos no autorizados, pérdida
        o alteración.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-101">
        4. Compartir Información
      </h3>
      <p data-id="element-102">
        No vendemos ni alquilamos tu información personal a terceros. Podemos
        compartir tu información con proveedores de servicios que nos ayudan a
        operar el programa (como procesadores de pago), siempre bajo estrictos
        acuerdos de confidencialidad.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-103">
        5. Cookies y Tecnologías Similares
      </h3>
      <p data-id="element-104">
        Utilizamos cookies y tecnologías similares para mejorar tu experiencia,
        recordar tus preferencias y analizar cómo se utiliza nuestro sitio web.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-105">6. Tus Derechos</h3>
      <p data-id="element-106">
        Tienes derecho a acceder, corregir o eliminar tu información personal.
        También puedes oponerte al procesamiento de tus datos u optar por no
        recibir comunicaciones de marketing. Para ejercer estos derechos,
        contacta a soporte@frecuenciaprohibida.com.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-107">
        7. Cambios en la Política de Privacidad
      </h3>
      <p data-id="element-108">
        Podemos actualizar esta política periódicamente. Te notificaremos
        cualquier cambio significativo mediante un aviso en nuestro sitio web o
        por correo electrónico.
      </p>
      <h3 className="text-xl font-bold text-indigo-900" data-id="element-109">8. Contacto</h3>
      <p data-id="element-110">
        Si tienes preguntas sobre esta política de privacidad, puedes
        contactarnos en soporte@frecuenciaprohibida.com.
      </p>
    </div>;
  return <footer className="bg-indigo-900 text-indigo-200 py-12 px-4 md:px-8 lg:px-16" data-id="element-111">
      <div className="max-w-7xl mx-auto" data-id="element-112">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10" data-id="element-113">
          <div data-id="element-114">
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-115">
              30 Días Frecuencia Prohibida
            </h3>
            <p className="mb-4" data-id="element-116">
              Programa de transformación energética y elevación de frecuencia
              vibratoria para manifestar la vida que mereces.
            </p>
            <p data-id="element-117">© {new Date().getFullYear()} Todos los derechos reservados.</p>
          </div>
          <div data-id="element-118">
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-119">
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2" data-id="element-120">
              <li data-id="element-121">
                <a href="#programa" className="hover:text-white transition" data-id="element-122">
                  El Programa
                </a>
              </li>
              <li data-id="element-123">
                <a href="#testimonios" className="hover:text-white transition" data-id="element-124">
                  Testimonios
                </a>
              </li>
              <li data-id="element-125">
                <a href="#inscripcion" className="hover:text-white transition" data-id="element-126">
                  Inscripción
                </a>
              </li>
              <li data-id="element-127">
                <a href="#preguntas" className="hover:text-white transition" data-id="element-128">
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-129">
            
            <ul className="space-y-2" data-id="element-130">
              
              
            </ul>
          </div>
          <div data-id="element-131">
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-132">Legal</h3>
            <ul className="space-y-2" data-id="element-133">
              <li data-id="element-134">
                <a href="#terminos" className="hover:text-white transition" onClick={openPopup('terminos')} data-id="element-135">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-136">
                <a href="#privacidad" className="hover:text-white transition" onClick={openPopup('privacidad')} data-id="element-137">
                  Política de Privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-indigo-800 mt-10 pt-6 text-sm" data-id="element-138">
          <p className="mb-4" data-id="element-139">
            AVISO LEGAL: Los resultados pueden variar de persona a persona. Este
            programa no sustituye ningún tratamiento médico o psicológico
            profesional. Consulta con un profesional de la salud antes de
            comenzar cualquier programa de desarrollo personal si tienes alguna
            condición médica preexistente.
          </p>
          <p data-id="element-140">
            Las frecuencias utilizadas en este programa no se recomiendan para
            personas con epilepsia o que utilizan marcapasos.
          </p>
        </div>
      </div>
      {/* Legal Popups */}
      <LegalPopup title="Términos y Condiciones" content={terminos} isOpen={activePopup === 'terminos'} onClose={closePopup} data-id="element-141" />
      <LegalPopup title="Política de Privacidad" content={privacidad} isOpen={activePopup === 'privacidad'} onClose={closePopup} data-id="element-142" />
    </footer>;
}